export const POINT_TABLE = {
    "baseball": {
        "en": [
            { "field_name": "team_fullname", "name": "Team", "title": "Total match" },
            { "field_name": "wg", "name": "W", "title": "Wins match" },
            { "field_name": "lg", "name": "L", "title": "Wins match" },
            { "field_name": "pct", "name": "Pct", "title": "Wins match" },
            { "field_name": "gb", "name": "GB", "title": "Wins match" },
            { "field_name": "home", "name": "Home", "title": "Wins match" },
            { "field_name": "away", "name": "Away", "title": "Wins match" },
            { "field_name": "rs", "name": "rs", "title": "Wins match" },
            { "field_name": "ra", "name": "ra", "title": "Wins match" }
        ],
        "sp": []
    },
    "football": {
        "sp": []
    }
}

export const baseball_index = 1;

export const BASEBALL_TEAM_STATISTICS_COLUMN = {
    "pitcher": {
        "table_1": {
            "name": { "sp": "Career-Pitching - All Splits", "en": "Career-Pitching" },
            "number": 19
        },
        "table_2": {
            "name": { "sp": "Expanded-Pitching - All Splits", "en": "Expanded-Pitching" },
            "number": 16
        },
        "table_3": {
            "name": { "sp": "Opponent-Batting - All Splits", "en": "Opponent-Batting" }
        }
    },
    "fielding": {
        "table_1": {
            "name": { "sp": "Career-Fielding - All Splits", "en": "Career-Fielding" },
            "number": 15
        },
        "table_2": {
            "name": { "sp": "Expanded-Fielding - All Splits", "en": "Expanded-Fielding" },
            "number": 13
        },
        "table_3": {
            "name": { "sp": "Advanced-Fielding - All Splits", "en": "Advanced-Fielding" }
        }
    },
    "batting": {
        "table_1": {
            "name": { "sp": "Career-Batting - All Splits", "en": "Career-Batting" },
            "number": 19
        },
        "table_2": {
            "name": { "sp": "Expanded-Batting - All Splits", "en": "Expanded-Batting" },
            "number": 9
        },
        "table_3": {
            "name": { "sp": "Advanced-Batting - All Splits", "en": "Advanced-Batting" }
        }
    }
}
export const BASEBALL_PLAYER_STATISTICS_SIDEBAR = {
    "en": [
        { "field_name": "season", "name": "Season" },
        { "field_name": "team_name", "name": "Team" }
    ],
    "sp": [
        { "field_name": "season", "name": "Estación" },
        { "field_name": "team_name", "name": "Equipo" },
    ]
}
export const BASEBALL_TEAM_STATISTICS_SIDEBAR = {
    "en": [
        { "field_name": "player_name", "name": "Player" },
        { "field_name": "player_position", "name": "Position" }
    ],
    "sp": [
        { "field_name": "player_name", "name": "Jugadora" },
        { "field_name": "player_position", "name": "Posición" }
    ]
}
export const BASEBALL_STATISTICS = {
    "pitcher": {
        "en": [
            { "field_name": "gp", "name": "gp", "title": "" },
            { "field_name": "gs", "name": "gs", "title": "" },
            { "field_name": "w", "name": "w", "title": "" },
            { "field_name": "l", "name": "l", "title": "" },
            { "field_name": "w-pr", "name": "w%", "title": "" },
            { "field_name": "war", "name": "war", "title": "" },
            { "field_name": "era", "name": "era", "title": "" },
            { "field_name": "whip", "name": "whip", "title": "" },
            { "field_name": "ip", "name": "ip", "title": "" },
            { "field_name": "k", "name": "k", "title": "" },
            { "field_name": "bb", "name": "bb", "title": "" },
            { "field_name": "k-bb", "name": "k/bb", "title": "" },
            { "field_name": "h", "name": "h", "title": "" },
            { "field_name": "r", "name": "r", "title": "" },
            { "field_name": "er", "name": "er", "title": "" },
            { "field_name": "sv", "name": "sv", "title": "" },
            { "field_name": "hld", "name": "hld", "title": "" },
            { "field_name": "blsv", "name": "blsv", "title": "" },

            { "field_name": "p-s", "name": "p/s", "title": "" },
            { "field_name": "p-i", "name": "p/i", "title": "" },
            { "field_name": "k-9", "name": "k/9", "title": "" },
            { "field_name": "qs", "name": "qs", "title": "" },
            { "field_name": "cg", "name": "cg", "title": "" },
            { "field_name": "sho", "name": "sho", "title": "" },
            { "field_name": "agsc", "name": "agsc", "title": "" },
            { "field_name": "gb", "name": "gb", "title": "" },
            { "field_name": "fb", "name": "fb", "title": "" },
            { "field_name": "g-f", "name": "g/f", "title": "" },
            { "field_name": "ir", "name": "ir", "title": "" },
            { "field_name": "irs", "name": "irs", "title": "" },
            { "field_name": "wp", "name": "wp", "title": "" },
            { "field_name": "blk", "name": "blk", "title": "" },
            { "field_name": "sb", "name": "sb", "title": "" },
            { "field_name": "cs", "name": "cs", "title": "" },
            { "field_name": "rsup", "name": "rsup", "title": "" },

            { "field_name": "p", "name": "p", "title": "" },
            { "field_name": "tbf", "name": "tbf", "title": "" },
            { "field_name": "p-tbf", "name": "p-tbf", "title": "" },
            { "field_name": "oba", "name": "oba", "title": "" },
            { "field_name": "oobp", "name": "oobp", "title": "" },
            { "field_name": "oslug", "name": "oslug", "title": "" },
            { "field_name": "oops", "name": "oops", "title": "" },
            { "field_name": "2b", "name": "2b", "title": "Doubles" },
            { "field_name": "3b", "name": "3b", "title": "Triples" },
            { "field_name": "hr", "name": "hr", "title": "" },
            { "field_name": "tb", "name": "tb", "title": "" },
            { "field_name": "rbi", "name": "rbi", "title": "" },
            { "field_name": "bh", "name": "bh", "title": "" },
            { "field_name": "sh", "name": "sh", "title": "" },
            { "field_name": "sf", "name": "sf", "title": "" },
            { "field_name": "ibb", "name": "ibb", "title": "" },
        ],
        "sp": [
            { "field_name": "gp", "name": "gp", "title": "" },
            { "field_name": "gs", "name": "gs", "title": "" },
            { "field_name": "w", "name": "w", "title": "" },
            { "field_name": "l", "name": "l", "title": "" },
            { "field_name": "w-pr", "name": "w%", "title": "" },
            { "field_name": "war", "name": "war", "title": "" },
            { "field_name": "era", "name": "era", "title": "" },
            { "field_name": "whip", "name": "whip", "title": "" },
            { "field_name": "ip", "name": "ip", "title": "" },
            { "field_name": "k", "name": "k", "title": "" },
            { "field_name": "bb", "name": "bb", "title": "" },
            { "field_name": "k-bb", "name": "k/bb", "title": "" },
            { "field_name": "h", "name": "h", "title": "" },
            { "field_name": "r", "name": "r", "title": "" },
            { "field_name": "er", "name": "er", "title": "" },
            { "field_name": "sv", "name": "sv", "title": "" },
            { "field_name": "hld", "name": "hld", "title": "" },
            { "field_name": "blsv", "name": "blsv", "title": "" },

            { "field_name": "p-s", "name": "p/s", "title": "" },
            { "field_name": "p-i", "name": "p/i", "title": "" },
            { "field_name": "k-9", "name": "k/9", "title": "" },
            { "field_name": "qs", "name": "qs", "title": "" },
            { "field_name": "cg", "name": "cg", "title": "" },
            { "field_name": "sho", "name": "sho", "title": "" },
            { "field_name": "agsc", "name": "agsc", "title": "" },
            { "field_name": "gb", "name": "gb", "title": "" },
            { "field_name": "fb", "name": "fb", "title": "" },
            { "field_name": "g-f", "name": "g/f", "title": "" },
            { "field_name": "ir", "name": "ir", "title": "" },
            { "field_name": "irs", "name": "irs", "title": "" },
            { "field_name": "wp", "name": "wp", "title": "" },
            { "field_name": "blk", "name": "blk", "title": "" },
            { "field_name": "sb", "name": "sb", "title": "" },
            { "field_name": "cs", "name": "cs", "title": "" },
            { "field_name": "rsup", "name": "rsup", "title": "" },

            { "field_name": "p", "name": "p", "title": "" },
            { "field_name": "tbf", "name": "tbf", "title": "" },
            { "field_name": "p-tbf", "name": "p-tbf", "title": "" },
            { "field_name": "oba", "name": "oba", "title": "" },
            { "field_name": "oobp", "name": "oobp", "title": "" },
            { "field_name": "oslug", "name": "oslug", "title": "" },
            { "field_name": "oops", "name": "oops", "title": "" },
            { "field_name": "2b", "name": "2b", "title": "Doubles" },
            { "field_name": "3b", "name": "3b", "title": "Triples" },
            { "field_name": "hr", "name": "hr", "title": "" },
            { "field_name": "tb", "name": "tb", "title": "" },
            { "field_name": "rbi", "name": "rbi", "title": "" },
            { "field_name": "bh", "name": "bh", "title": "" },
            { "field_name": "sh", "name": "sh", "title": "" },
            { "field_name": "sf", "name": "sf", "title": "" },
            { "field_name": "ibb", "name": "ibb", "title": "" },
        ]
    },
    "fielding": {
        "en": [
            { "field_name": "pos", "name": "pos", "title": "Position" },
            { "field_name": "gp", "name": "gp", "title": "Games Played" },
            { "field_name": "gs", "name": "gs", "title": "Games Started" },
            { "field_name": "fip", "name": "fip", "title": "Full Innings" },
            { "field_name": "tc", "name": "tc", "title": "Total Chances" },
            { "field_name": "po", "name": "po", "title": "Pickoffs" },
            { "field_name": "a", "name": "a", "title": "Assists" },
            { "field_name": "e", "name": "e", "title": "Errors" },
            { "field_name": "dp", "name": "dp", "title": "Double Plays" },
            { "field_name": "fp", "name": "fp", "title": "Fielding Percentage" },
            { "field_name": "rf", "name": "rf", "title": "Range Factor" },
            { "field_name": "pb", "name": "pb", "title": "Passed Balls" },
            { "field_name": "sba", "name": "sba", "title": "Stolen Bases Allowed" },
            { "field_name": "cs", "name": "cs", "title": "Caught Stealing" },
            { "field_name": "cs-pr", "name": "cr%", "title": "Caught Stealing Percentage" },
            { "field_name": "era", "name": "era", "title": "Earned Run Average" },
            { "field_name": "dwar", "name": "dwar", "title": "Defensive Wins Above Replacement" },
        ],
        "sp": [
            { "field_name": "pos", "name": "pos", "title": "Posición" },
            { "field_name": "gp", "name": "gp", "title": "Juegos jugados" },
            { "field_name": "gs", "name": "gs", "title": "Juegos iniciados" },
            { "field_name": "fip", "name": "fip", "title": "Entradas Completas" },
            { "field_name": "tc", "name": "tc", "title": "Posibilidades Totales" },
            { "field_name": "po", "name": "po", "title": "Selecciones" },
            { "field_name": "a", "name": "a", "title": "Asistencias" },
            { "field_name": "e", "name": "e", "title": "Errores" },
            { "field_name": "dp", "name": "dp", "title": "Jugadas Dobles" },
            { "field_name": "fp", "name": "fp", "title": "Porcentaje De Fildeo" },
            { "field_name": "rf", "name": "rf", "title": "Factor de rango" },
            { "field_name": "pb", "name": "pb", "title": "Bolas Pasadas" },
            { "field_name": "sba", "name": "sba", "title": "Bases robadas permitidas" },
            { "field_name": "cs", "name": "cs", "title": "Atrapado Robando" },
            { "field_name": "cs-pr", "name": "cr%", "title": "Porcentaje de robo atrapado" },
            { "field_name": "era", "name": "era", "title": "Promedio de carrera ganado" },
            { "field_name": "dwar", "name": "dwar", "title": "Victorias defensivas por encima del reemplazo" },
        ]
    },
    "batting": {
        "en": [
            { "field_name": "gp", "name": "gp", "title": "Games Played" },
            { "field_name": "ab", "name": "ab", "title": "At Bats" },
            { "field_name": "r", "name": "r", "tfitle": "Runs" },
            { "field_name": "h", "name": "h", "title": "Hits" },
            { "field_name": "2b", "name": "2b", "title": "Doubles" },
            { "field_name": "3b", "name": "3b", "title": "Triples" },
            { "field_name": "hr", "name": "hr", "title": "Home Runs" },
            { "field_name": "rbi", "name": "rbi", "title": "Runs Batted In" },
            { "field_name": "bb", "name": "bb", "title": "Walks" },
            { "field_name": "hbp", "name": "hbp", "title": "Hit By Pitch" },
            { "field_name": "so", "name": "so", "title": "Strikeouts" },
            { "field_name": "sb", "name": "sb", "title": "Stolen Bases" },
            { "field_name": "cs", "name": "cs", "title": "Caught Stealing" },
            { "field_name": "avg", "name": "avg", "title": "Batting Average" },
            { "field_name": "obp", "name": "obp", "title": "On Base Percentage" },
            { "field_name": "slg", "name": "slg", "title": "Slugging Percentage" },
            { "field_name": "ops", "name": "ops", "title": "OPB Pct + SLG Pct" },
            { "field_name": "war", "name": "war", "title": "Wins Above Replacement" },

            { "field_name": "pa", "name": "pa", "title": "Plate Appearances" },
            { "field_name": "p", "name": "p", "title": "Pitches" },
            { "field_name": "p-pa", "name": "p/pa", "title": "Pitches Per Plate Appearance" },
            { "field_name": "xbh", "name": "xbh", "title": "Extra Base Hits" },
            { "field_name": "tb", "name": "tb", "title": "Total Bases" },
            { "field_name": "ibb", "name": "ibb", "title": "Intentional Walks" },
            { "field_name": "gidp", "name": "gidp", "title": "Ground Into Double Play" },
            { "field_name": "sh", "name": "sh", "title": "Sacrifice Hit" },
            { "field_name": "sf", "name": "sf", "title": "Sacrifice Flies" },
            { "field_name": "sb-pr", "name": "sb%", "title": "Stolen Base Percentage" },

            { "field_name": "owar", "name": "owar", "title": "Offensive Wins Above Replacement" },
            { "field_name": "rc", "name": "rc", "title": "Runs Created" },
            { "field_name": "rc-27", "name": "rc/27", "title": "Runs Created Per 27 Outs" },
            { "field_name": "isop", "name": "isop", "title": "Isolated Power" },
            { "field_name": "seca", "name": "seca", "title": "Secondary Average" },
            { "field_name": "ab-hr", "name": "ab/hr", "title": "At Bats Per Home Run" },
            { "field_name": "bb-pa", "name": "bb/pa", "title": "Walks Per Plate Appearance" },
            { "field_name": "bb-k", "name": "bb/k", "title": "Walk To Strikeout Ratio" },
            { "field_name": "go", "name": "go", "title": "Ground Balls" },
            { "field_name": "fo", "name": "fo", "title": "Fly Balls" },
            { "field_name": "go-fo", "name": "go/fo", "title": "Ground To Fly Ball Ratio" },
        ],
        "sp": [
            { "field_name": "gp", "name": "gp", "title": "Juegos jugados" },
            { "field_name": "ab", "name": "ab", "title": "Al Bate" },
            { "field_name": "r", "name": "r", "tfitle": "Carreras" },
            { "field_name": "h", "name": "h", "title": "Golpes" },
            { "field_name": "2b", "name": "2b", "title": "Dobles" },
            { "field_name": "3b", "name": "3b", "title": "Triples" },
            { "field_name": "hr", "name": "hr", "title": "Jonrones" },
            { "field_name": "rbi", "name": "rbi", "title": "Carreras Impulsadas" },
            { "field_name": "bb", "name": "bb", "title": "Camina" },
            { "field_name": "hbp", "name": "hbp", "title": "Golpeado Por Lanzamiento" },
            { "field_name": "so", "name": "so", "title": "Ponches" },
            { "field_name": "sb", "name": "sb", "title": "Bases Robadas" },
            { "field_name": "cs", "name": "cs", "title": "Atrapado Robando" },
            { "field_name": "avg", "name": "avg", "title": "Promedio De Bateo" },
            { "field_name": "obp", "name": "obp", "title": "Porcentaje Base" },
            { "field_name": "slg", "name": "slg", "title": "Porcentaje De Slugging" },
            { "field_name": "ops", "name": "ops", "title": "Porcentaje OPB + Porcentaje SLG" },
            { "field_name": "war", "name": "war", "title": "Gana Por Encima Del Reemplazo" },

            { "field_name": "pa", "name": "pa", "title": "Apariciones en placa" },
            { "field_name": "p", "name": "p", "title": "Parcelas" },
            { "field_name": "p-pa", "name": "p/pa", "title": "Lanzamientos por apariencia de plato" },
            { "field_name": "xbh", "name": "xbh", "title": "Golpes de base extra" },
            { "field_name": "tb", "name": "tb", "title": "Bases Totales" },
            { "field_name": "ibb", "name": "ibb", "title": "Paseos intencionales" },
            { "field_name": "gidp", "name": "gidp", "title": "Ground en Double Play" },
            { "field_name": "sh", "name": "sh", "title": "Golpe de sacrificio" },
            { "field_name": "sf", "name": "sf", "title": "sacrificar moscas" },
            { "field_name": "sb-pr", "name": "sb%", "title": "Porcentaje base robado" },

            { "field_name": "owar", "name": "owar", "title": "Ofensivo gana por encima del reemplazo" },
            { "field_name": "rc", "name": "rc", "title": "Ejecuciones creadas" },
            { "field_name": "rc-27", "name": "rc/27", "title": "Carreras creadas por 27 outs" },
            { "field_name": "isop", "name": "isop", "title": "Poder aislado" },
            { "field_name": "seca", "name": "seca", "title": "Promedio Secundario" },
            { "field_name": "ab-hr", "name": "ab/hr", "title": "Al bate por jonrón" },
            { "field_name": "bb-pa", "name": "bb/pa", "title": "Paseos por aparición en el plato" },
            { "field_name": "bb-k", "name": "bb/k", "title": "Proporción de caminata a tachado" },
            { "field_name": "go", "name": "go", "title": "Bolas de tierra" },
            { "field_name": "fo", "name": "fo", "title": "Bolas voladoras" },
            { "field_name": "go-fo", "name": "go/fo", "title": "Proporción de bola de tierra a vuelo" },
        ]
    },
    "player_profile": {
        "en": {
            "in_at": "In At" ,
            "position": "Position",
            "country": "Country",
            "player_info": "Player Info",
            "name": "Name",
            "ht_wt": "ht/wt",
            "dob": "dob",
            "bat_thr": "bat/thr",
            "birthplace": "birthplace",
            "status": "status",
            "status_active": "Active",
            "status_inactive": "InActive",
            "overview": "Player Overview",
            "statistics": "Player Statistics",
            "gallery": "Player Gallery",
            "videos": "Player Videos",
            "latest_news": "Latest News"
        },
        "sp": {
            "in_at": "en a las" ,
            "position": "Posición",
            "country": "País",
            "player_info": "Información del jugador",
            "name": "Nombre",
            "ht_wt": "alto/peso",
            "dob": "fecha de nacimiento",
            "bat_thr": "bate/jueves",
            "birthplace": "lugar de nacimiento",
            "status": "estado",
            "status_active": "Activo",
            "status_inactive": "Inactivo",
            "overview": "Resumen del jugador",
            "statistics": "Estadísticas del jugador",
            "gallery": "Galería de jugadores",
            "videos": "Vídeos del reproductor",
            "latest_news": "Últimas noticias"
        }
    }
}

export const BASEBALL_STATISTICS_COLUMN = {
    "pitcher": {
        "table_1": {
            "name": { "sp": "Lanzamiento De Carrera", "en": "Career Pitching" },
            "number": 19
        },
        "table_2": {
            "name": { "sp": "Lanzamiento Ampliado", "en": "Expanded Pitching" },
            "number": 16
        },
        "table_3": {
            "name": { "sp": "Oponente Bateo", "en": "Opponent Batting" }
        }
    },
    "fielding": {
        "table_1": {
            "name": { "sp": "Campo De Carrera", "en": "Career Fielding" },
            "number": 15
        },
        "table_2": {
            "name": { "sp": "Campo Ampliado", "en": "Expanded Fielding" },
            "number": 13
        },
        "table_3": {
            "name": { "sp": "Campo Avanzado", "en": "Advanced Fielding" }
        }
    },
    "batting": {
        "table_1": {
            "name": { "sp": "Carrera De Bateo", "en": "Career Batting" },
            "number": 19
        },
        "table_2": {
            "name": { "sp": "Bateo Ampliado", "en": "Expanded Batting" },
            "number": 9
        },
        "table_3": {
            "name": { "sp": "Bateo Avanzado", "en": "Advanced Batting" }
        }
    }
}
export const BASEBALL_TEAM_STATISTICS = {
    "team_profile": {
        //Do not Change order of data
        "en": {
            "fullname": "Full Name" ,
            "owner": "Owner",
            "overview": "Team Overview",
            "statistics": "Team Statistics",
            "gallery": "Team Gallery",
            "videos": "Team Videos",
            "latest_news": "Latest News"
        },
        "sp": {
            "fullname": "Nombre Completo" ,
            "owner": "Duena",
            "overview": "Resumen del equipo",
            "statistics": "Estadísticas del equipo",
            "gallery": "Galería del equipo",
            "videos": "Vídeos del equipo",
            "latest_news": "Últimas noticias"
        }
    }
}

export const BASEBALL_STATISTICS_MENU = {
    "en": {
        "title": "Stats",
        "dropdown_default": "Select Statistics",
        "dropdown_batting": "Batting",
        "dropdown_fielding": "Fielding",
        "dropdown_pitching": "Pitching",
    },
    "sp": {
        "title": "Estadísticas",
        "dropdown_default": "Seleccione Estadísticas",
        "dropdown_batting": "Guata",
        "dropdown_fielding": "Fildeo",
        "dropdown_pitching": "Cabeceo",
    }
}

export const BASEBALL_SIMILAR_PLAYERS = {
    "en": {
        title: "Similar Players",
        link_text: "Check Detail"
    },
    "sp": {
        title: "Jugadoras Similares",
        link_text: "Comprobar detalle"
    }
}

export const BASEBALL_TEAMS_LIST = {
    "en": {
        title: "",
        link_text: "Check Details"
    },
    "sp": {
        title: "",
        link_text: "Comprobar detalle"
    }
}

export const RECENT_STORIES = {
    "en": {
        title: "Recent Stories",
        link_text: ""
    },
    "sp": {
        title: "Historias recientes",
        link_text: ""
    }
}

export const OUR_GALLERY = {
    "en": {
        "title": "Our Gallery",
        "subtitle": "Your Amazing Memories & Tours"
    },
    "sp": {
        "title": "Nuestro Galeria",
        "subtitle": "Tus increíbles recuerdos y recorridos"
    }
}